import React, { Component } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { orderApiService } from "../../services/otodis/OrderApiService";
import { Tooltip, Button, Col, Modal, Row, Table, DatePicker, Form, Input } from "antd";
import { CloudSyncOutlined, CopyOutlined } from "@ant-design/icons";
import { TransferTaxControlStates } from "./types/TransferTaxControlTypes";
import moment from "moment";
import ServicebureauSelect from "../../components/servicebureau/ServicebureauSelect";
import { Select } from "antd";

export interface TransferTaxControlProps {}

class TransferTaxControl extends Component<TransferTaxControlProps & any, TransferTaxControlStates> {
  private readonly initState!: TransferTaxControlStates;
  private tableColumn: any = [
    {
      title: "Kode Order",
      dataIndex: "order_code",
      width: 170,
      render: (value: string, row: []) => {
        return (
          <React.Fragment>
            <span className={`font-90-link`} onClick={(event) => this.showDetail(row)}>
              {value}
            </span>
            &nbsp; &nbsp;
            <Tooltip title="Click untuk copy kode order" color={"cyan"}>
              <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
            </Tooltip>
          </React.Fragment>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "transfer_title_status",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Tgl Closing",
      dataIndex: "order_closing_date",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Tgl BAST",
      dataIndex: "handover_delivery_date",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Tgl Penugasan",
      dataIndex: "create_date",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Nama Konsumen",
      dataIndex: "customer_doc_name",
      width: 150,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Nomor Mesin",
      dataIndex: "vehicle_engine_number",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Nomor Invoice",
      dataIndex: "invoice_number",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Nomor STNK",
      dataIndex: "vehicle_registration_certificate_number",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Tgl Masuk STNK",
      dataIndex: "vehicle_registration_certificate_entry_date",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Nilai BBN",
      dataIndex: "transfer_title_cost",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Kode Biro Jasa",
      dataIndex: "service_bureau_code",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Nama Biro Jasa",
      dataIndex: "service_bureau_name",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
  ];

  constructor(props: (TransferTaxControlProps & any) | any) {
    super(props);

    this.initState = {
      processing: false,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      processingFetchDetailTableData: true,
      processingFetchTableData: false,
      dataOrder: [],
      pageSize: 100,
      showModalDetailStock: false,
      dataDetailStock: [],
      supplierCode: "",
      supplierName: "",
      vehicleEngineNumber: "",
      selectStatus: "INPUTED",
      filterStartDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
      filterEndDate: moment().clone().endOf("month").format("YYYY-MM-DD"),
      selectStatusNotice: "ALL",
    };
    this.state = { ...this.initState };
  }

  closeModalDetailStock = (data: any) => {
    this.setState({
      showModalDetailStock: false,
    });
  };

  copyToClipboard = async (data: any) => {
    await navigator.clipboard.writeText(data);
  };

  showDetail = async (data: any) => {
    await this.promisedSetState({
      dataDetailStock: data,
      showModalDetailStock: true,
    });
  };

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      processingFetchTableData: true,
      dealerCode: data.value,
    });

    await this.fetchStockData();
  };

  fetchStockData = async () => {
    if (!this.state.vehicleEngineNumber) {
      if (!this.state.supplierCode) {
        Modal.error({
          title: "Error Validasi",
          content: "Biro jasa harus dipilih",
        });
        return false;
      }

      if (!this.state.selectStatus) {
        Modal.error({
          title: "Error Validasi",
          content: "Status haru dipilih ",
        });
        return false;
      }

      if (!this.state.dealerCode) {
        Modal.error({
          title: "Error Validasi",
          content: "Invalid Dealer ",
        });
        return false;
      }
    }

    await this.promisedSetState({
      dataOrder: [],
      processingFetchTableData: true,
    });

    orderApiService
      .getTransferTaxControl({
        dealerCode: this.state.dealerCode,
        startDate: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
        endDate: moment(this.state.filterEndDate).format("YYYY-MM-DD"),
        transferTitleStatus: this.state.selectStatus,
        serviceBureauCode: this.state.supplierCode,
        vehicleEngineNumber: this.state.vehicleEngineNumber,
        noticeUploaded: this.state.selectStatusNotice === "UPLOADED" ? true : false,
      })
      .then(async (value) => {
        await this.promisedSetState({
          dataOrder: value.data.success.data,
          processingFetchTableData: false,
        });
      })
      .catch(async (reason) => {
        await this.promisedSetState({
          dataOrder: [],
          processingFetchTableData: false,
        });
      });
  };

  onChangeTable = (pagination: any, filters: any, sorter: any) => {
    console.log(pagination);
    console.log(filters);
    console.log(sorter);
    if (pagination?.pageSize) {
      this.setState({
        pageSize: pagination?.pageSize,
      });
    }
  };

  onWarehouseStartDate = (data: any) => {
    this.setState({
      filterStartDate: data,
    });
  };

  onWarehouseEndDate = (data: any) => {
    this.setState({
      filterEndDate: data,
    });
  };

  onSupplierChange = (data: any) => {
    this.setState({
      supplierCode: data.value,
      supplierName: data.children,
    });
  };

  onChangeStatus = (value: any, option: any) => {
    this.setState({
      selectStatus: value,
    });
  };

  onChangeStatusNotice = (value: any, option: any) => {
    this.setState({
      selectStatusNotice: value,
    });
  };

  onStringFieldChange = <T extends keyof Pick<any, "vehicleEngineNumber">>(target: T, value: any) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "vehicleEngineNumber":
        currentState.vehicleEngineNumber = value;
        break;
    }

    this.setState({
      ...currentState,
    });
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          noPadNoMar={true}
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Dokumen`}
          breadcrumbMenu={`Kontrol Penugasan`}
          defaultSelectedKeys={["m-control-bbn"]}
          defaultOpenKeys={["sm-document"]}
        >
          <div style={{ padding: 24 }}>
            <Form layout={`vertical`}>
              <Row>
                <Col style={{ paddingLeft: 2, paddingRight: 2 }}>
                  <Form.Item className={"padTop-10"} style={{ minWidth: 180 }} label="Dealer">
                    <ServicebureauSelect onSupplierChangeProps={this.onSupplierChange} dealerCode={this.state.dealerCode} value={this.state.supplierCode} />
                  </Form.Item>
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2 }}>
                  {" "}
                  <Form.Item className={"padTop-10"} style={{ minWidth: 140 }} label="Status BBN">
                    <Select
                      showSearch
                      placeholder="Pilih Status"
                      optionFilterProp="children"
                      onChange={this.onChangeStatus}
                      filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      value={this.state.selectStatus}
                    >
                      <Select.Option key={`INPUTED`} value={`INPUTED`}>{`INPUTED`}</Select.Option>
                      <Select.Option key={`UPLOADED`} value={`UPLOADED`}>{`UPLOADED`}</Select.Option>
                      <Select.Option key={`GENERATED`} value={`GENERATED`}>{`GENERATED`}</Select.Option>
                      <Select.Option key={`FINISHED`} value={`FINISHED`}>{`FINISHED`}</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2 }}>
                  <Form.Item className={"padTop-10"} style={{ minWidth: 140 }} label="Status Notice">
                    <Select
                      showSearch
                      placeholder="Pilih Status Notice"
                      optionFilterProp="children"
                      onChange={this.onChangeStatusNotice}
                      filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      value={this.state.selectStatusNotice}
                    >
                      <Select.Option key={`ALL`} value={`ALL`}>{`ALL`}</Select.Option>
                      <Select.Option key={`UPLOADED`} value={`UPLOADED`}>{`UPLOADED`}</Select.Option>
                      <Select.Option key={`NOT_UPLOADED`} value={`NOT_UPLOADED`}>{`NOT UPLOADED`}</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2 }}>
                  <Form.Item className={"padTop-10"} label="Tanggal Awal">
                    <DatePicker defaultValue={moment(this.state.filterStartDate, "YYYY-MM-DD")} onChange={(event) => this.onWarehouseStartDate(event)} format={"YYYY-MM-DD"} />
                  </Form.Item>
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2 }}>
                  <Form.Item className={"padTop-10"} label="Tanggal Akhir">
                    <DatePicker defaultValue={moment(this.state.filterEndDate, "YYYY-MM-DD")} onChange={(event) => this.onWarehouseEndDate(event)} format={"YYYY-MM-DD"} />
                  </Form.Item>
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2 }}>
                  <Form.Item className={"padTop-10"} label="Nomor Mesin">
                    <Input value={this.state.vehicleEngineNumber} onChange={(event) => this.onStringFieldChange("vehicleEngineNumber", event.target.value)} placeholder="Nomor Mesin" />
                  </Form.Item>
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2 }}>
                  <Form.Item className={"padTop-10"} label="&nbsp;">
                    <Button onClick={this.fetchStockData} type="primary" icon={<CloudSyncOutlined />}>
                      {" "}
                      Go{" "}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
          <br />
          <Table
            rowKey={"order_code"}
            size={"small"}
            scroll={{ x: "calc(500px + 50%)" }}
            loading={this.state.processingFetchTableData}
            columns={this.tableColumn}
            dataSource={this.state.dataOrder}
            pagination={{ pageSize: this.state.pageSize }}
            onChange={this.onChangeTable}
          />

          <Modal
            visible={this.state.showModalDetailStock}
            title="Detail Order"
            onOk={this.closeModalDetailStock}
            onCancel={this.closeModalDetailStock}
            width={"50%"}
            cancelText={"Tutup"}
            okText={false}
            footer={[
              <Button key="back" type="primary" onClick={this.closeModalDetailStock}>
                Tutup
              </Button>,
            ]}
          >
            <Row>
              <Col span={8} className={`col-grey`}>
                Kode Order:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.order_code}</Col>
              <Col span={8} className={`col-grey`}>
                Status:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.transfer_title_status}</Col>
              <Col span={8} className={`col-grey`}>
                Nilai Invoice:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.invoice_number}</Col>
              <Col span={8} className={`col-grey`}>
                Nilai BBN:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.transfer_title_cost}</Col>

              <Col span={8} className={`col-grey`}>
                Biaya Pembuatan Surat Notice:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.notice_cost}</Col>
              <Col span={8} className={`col-grey`}>
                Biaya Lain Lain:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.others_cost}</Col>
              <Col span={8} className={`col-grey`}>
                Penalty:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.penalty}</Col>
              <Col span={8} className={`col-grey`}>
                Biaya Process:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.process_cost}</Col>
              <Col span={8} className={`col-grey`}>
                Biaya Progressive:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.progressive_cost}</Col>
              <Col span={8} className={`col-grey`}>
                Akun Biro Jasa:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.service_bureau_account_number}</Col>
              <Col span={8} className={`col-grey`}>
                Kode Biro Jasa:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.service_bureau_code}</Col>
              <Col span={8} className={`col-grey`}>
                Nama Biro Jasa:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.service_bureau_name}</Col>
              <Col span={8} className={`col-grey`}>
                Biaya Service:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.service_cost}</Col>
              <Col span={8} className={`col-grey`}>
                Tgl Masuk Dokumen:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_certificate_of_ownership_entry_date}</Col>
              <Col span={8} className={`col-grey`}>
                BPKB:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_certificate_of_ownership_number}</Col>
              <Col span={8} className={`col-grey`}>
                Tgl Penyerahan Dokumen:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_certificate_of_ownership_submission_date}</Col>
              <Col span={8} className={`col-grey`}>
                Nomor Mesin Kendaraan:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_engine_number}</Col>
              <Col span={8} className={`col-grey`}>
                Tgl Masuk Dokumen:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_license_entry_date}</Col>
              <Col span={8} className={`col-grey`}>
                Nomor Polisi:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_license_plate}</Col>
              <Col span={8} className={`col-grey`}>
                Tgl Penyerahan Dokumen:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_license_submission_date}</Col>
              <Col span={8} className={`col-grey`}>
                Tgl Masuk Dokumen Notice:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_notice_entry_date}</Col>
              <Col span={8} className={`col-grey`}>
                Dokumen Notice:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_notice_number}</Col>
              <Col span={8} className={`col-grey`}>
                Tgl Penyerahan Dokumen Notice:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_notice_submission_date}</Col>
              <Col span={8} className={`col-grey`}>
                Tgl Masuk Dokumen (STNK):
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_registration_certificate_entry_date}</Col>
              <Col span={8} className={`col-grey`}>
                STNK:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_registration_certificate_number}</Col>
              <Col span={8} className={`col-grey`}>
                Tgl Penyerahan Dokumen (STNK):
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_registration_certificate_submission_date}</Col>
              <Col span={8} className={`col-grey`}>
                createdate:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.createdate}</Col>
            </Row>
            <br />
          </Modal>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(TransferTaxControl), 12);
